<template>
  <div class="sm-wrap lg">
    <group-maillist
      :list="mailList"
      @action="groupMailAction"
    />

    <paginate-block
      v-if="mailList.length"
      v-model="pager.onPage"
      :pages="pager.pages" 
      :page="pager.page"
      :onPage="pager.onPage"
      :morePages="morePages"
      :items="pager.items"
      @showMore="getMoreGroupMail"
    />

    <popup-block
      v-if="popup.isOpen"
      :open="popup.isOpen"
      :class="'sm-list__popup'"
      :size="popup.type == 'reminder' ? 'large' : ''"
      @close="popup.isOpen = false;"
    >
      <template slot="popupContent">
        <div
          v-if="popup.type == 'reminder'"
          class="sm-list__popup-reminder"
        >
          <h4>Remind me on</h4>
          <div class="sm-list__popup-reminder-main">
            <div class="sm-list__popup-reminder-main-links">
              <a
                href="#"
                @click.prevent="setReminderDate('week', 1)"
              >In a week</a>
              <a
                href="#"
                @click.prevent="setReminderDate('week', 2)"
              >In a two weeks</a>
              <a
                href="#"
                @click.prevent="setReminderDate('month', 1)"
              >In a month</a>
              <a
                href="#"
                @click.prevent="setReminderDate('month', 2)"
              >In a two month</a>
            </div>
            <datepicker-wrap
              v-model="reminderDate"
              :inline="true"
              :notBefore="new Date().setDate(new Date().getDate() - 1)"
            />
          </div>
          <btn-block
            :text="'Remind me'"
            :class="{'disabled': !reminderDate}"
            @click="setReminder"
          />
        </div>
        <confirm-block
          v-else-if="popup.type == 'confirm-del'"
          :text="`Group Mail #${this.popup.item.id} will be deleted.`"
          :confirmType="'error'"
          @confirm="confirmDelete"
          @cancel="popup.isOpen = false"
        />
      </template>
    </popup-block>

    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
import GroupMailList from '@/views/admin/pages/mail/components/GroupMailList';
import Spinner from '@/components/Spinner';
import PaginateBlock from '@/components/PaginateBlock';
import Popup from '@/components/Popup';
import DatepickerWrap from '@/components/DatepickerWrap';
import Confirm from '@/components/Confirm';
import { mapActions } from 'vuex';

export default {
  name: 'group-controller',
  components: {
    'group-maillist': GroupMailList,
    'sm-spinner': Spinner,
    'paginate-block': PaginateBlock,
    'popup-block': Popup,
    'datepicker-wrap': DatepickerWrap,
    'confirm-block': Confirm,
  },
  data() {
    return {
      showSpinner: false,
      list: [],
      more: [],
      pager: {
        page: 1,
        pages: 1,
        items: 1,
        onPage:24
      },
      morePages: 0,
      popup: {
        isOpen: false,
        item: null,
        type: null // values: reminder, confirm-del
      },
      reminderDate: null,
    };
  },
  created() {
    this.getGroupMail();
  },
  computed: {
    mailList() {
      return [...this.list, ...this.more];
    }
  },
  methods: {
    ...mapActions({
      getAdminGroupList: 'mail/getAdminGroupList',
      changeAdminGroupMail: 'mail/changeAdminGroupMail',
      deleteAdminGroupMail: 'mail/deleteAdminGroupMail',
    }),
    groupMailAction(data) {
      switch(data.action) {
        case 'forward':
          this.$router.push(`group-forwarding?mail_number=${data.id}`);
          break;
        case 'reminder':
          this.popup = {
            isOpen: true,
            item: this.mailList.find(item => item.id == data.id),
            type: 'reminder'
          }
          break;
        case 'delete':
          this.popup = {
            isOpen: true,
            item: this.mailList.find(item => item.id == data.id),
            type: 'confirm-del'
          }
          break;
        default:
          break;
      }
    },
    setReminderDate(term, qty) {
      let today = new Date();
      let newDate;

      if (term == 'week')
        newDate = new Date().setDate(today.getDate() + (7 * qty));
      else
        newDate = new Date().setMonth(today.getMonth() + qty);

      this.reminderDate = this.$moment(newDate).format('YYYY-MM-DD');
      this.setReminder();
    },
    setReminder() {
      this.popup.isOpen = false;
      this.showSpinner = true;
      this.changeAdminGroupMail({
        id: this.popup.item.id,
        params: {
          remainder: this.reminderDate
        }
      })
        .then(res => {
          window.location.reload();
        })
      
    },
    getGroupMail() {
      this.showSpinner = true;
      this.morePages = 0;

      let query = Object.assign({}, this.$route.query);

      if (!query.limit)
        query.limit = 24;

      this.getAdminGroupList(query)
        .then(list => {
          this.pager.page = list.page;
          this.pager.pages = list.total_pages;
          this.pager.items = list.total_count;
          this.pager.onPage = parseInt(query.limit) || 24;
          this.list = list.group_mails;
          this.showSpinner = false;
        });
    },
    getMoreGroupMail() {
      this.showSpinner = true;
      this.morePages++;

      let query = Object.assign({}, this.$route.query);
      query.page = this.pager.page + this.morePages;
      query.limit = this.pager.onPage;

      this.getAdminGroupList(query)
        .then(list => {
          this.more = [...this.more, ...list.group_mails];
          this.showSpinner = false;
        });
    },
    confirmDelete() {
      this.showSpinner = true;
      this.popup.isOpen = false;
      this.deleteAdminGroupMail(this.popup.item.id)
        .then(res => {
          window.location.reload();
        });
    }
  },
  watch: {
    '$route.query'(val) {
      this.getGroupMail(val);
    }
  }
}
</script>